import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';

function TeamsPickerReturnTeamDoc({team: selectedTeam, setTeam}) {

    const [show, setShow] = useState(false)
    const [teams, setTeams] = useState([])

    useEffect(() => {

        try {
            const teamsRef = firestore.collection("teams");
            teamsRef.orderBy("team_name").onSnapshot(({docs}) => {
                const teams = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setTeams(teams)
            })
        } catch (error) {
            console.log(error)
        }

    }, [])

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    function clickHandler(team) {
        setTeam(team)
        setShow(false)
    }

    return (
        <React.Fragment>
            <div className="card card-header" onClick={toggle}>
                <div >
                    Velg lag: <span className="font-weight-bold">{selectedTeam?.team_name}</span>
                    <span className="float-right"><i className={`fas fa-chevron-${show ? "up" : "down"}`}></i> </span>
                </div>
            </div>
            {show && <ul className="list-group">
                {teams?.map((team, index) => {

                    const isSelected = team.id === selectedTeam?.id
                    console.log(team.id, selectedTeam?.id)

                    return (
                        <li className="list-group-item" key={index}>
                            <img src={team.team_logo} style={{maxWidth: "30px"}} /> <span>{team.team_name}</span>
                            <span className="float-right">
                                <div style={{cursor: "pointer"}} className={isSelected ? "px-2 py-1 bg-primary" : "px-2 py-1 bg-success"} onClick={() => clickHandler(team)}>
                                    <i className={`fas fa-${isSelected ? "check" : "plus"}`}></i>
                                </div>
                            </span>
                        </li>
                    )
                })}
            </ul>}
        </React.Fragment>
    )
}
export default TeamsPickerReturnTeamDoc